const makeMegaNavAccessible = () => {
  const detailsElements = document.querySelectorAll(
    'details[is="details-dropdown"], details[is="details-mega"]'
  );

  detailsElements.forEach((details) => {
    const summary = details.querySelector("summary");

    summary.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();

        const isOpen = details.hasAttribute("open");

        details.open = !isOpen;

        summary.setAttribute("aria-expanded", String(!isOpen));
      }
    });

    details.addEventListener("toggle", () => {
      summary.setAttribute("aria-expanded", details.open ? "true" : "false");
    });
  });
};

const drawerFocus = () => {
  const toggleButtons = document.querySelectorAll(".header-nav-drawer-toggle");
  const drawer = document.getElementById("MenuDrawer");
  const drawerContent = drawer.querySelector(".drawer__content");

  const focusFirstElement = (container) => {
    const focusableSelectors = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      '[tabindex]:not([tabindex="-1"])',
      "summary",
    ];

    const firstFocusable = container.querySelector(
      focusableSelectors.join(", ")
    );

    if (firstFocusable) firstFocusable.focus();
  };

  toggleButtons.forEach((button) => {
    if (!drawer) return;

    button.addEventListener("click", () => {
      setTimeout(() => {
        focusFirstElement(drawerContent);
      }, 500);
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  makeMegaNavAccessible();
  drawerFocus();
});
